/** Motivos de rechazo de vehículo (admin → conductor). */
export const CAR_REJECT_REASONS = [
  {
    code: 'reupload_car_image',
    es: 'Vuelve a subir imagen de vehículo',
    en: 'Please re-upload the vehicle photo',
  },
  {
    code: 'reupload_registration',
    es: 'Vuelve a subir imagen de matrícula',
    en: 'Please re-upload the registration card photo',
  },
  {
    code: 'model_not_accepted',
    es: 'Modelo de vehículo no aceptado',
    en: 'Vehicle model is not accepted',
  },
  {
    code: 'other',
    es: 'Otros',
    en: 'Other',
  },
];

export function carRejectReasonLabel(code, locale = 'es', otherText = '') {
  const row = CAR_REJECT_REASONS.find((r) => r.code === code);
  const lang = String(locale || 'es').toLowerCase().startsWith('en') ? 'en' : 'es';
  if (!row) return otherText || (lang === 'en' ? 'Rejected' : 'Rechazado');
  if (code === 'other' && otherText) return otherText;
  return row[lang] || row.es;
}
